module.exports = __webpack_public_path__ + "img/anf3.05a562cf.png";